import styled from 'styled-components';
import {Paper} from "@material-ui/core";

export const ParentStyled = styled.div`
    display: flex;
    justify-content: center;
    align-items: start;
    flex-direction: column;
`;

export const ContainerInputStyled = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    height: 55px;
    border-style: solid;
    border-width: 1px;
    border-color: #b2b2b2;
    padding: 10px;
    border-radius: 4px;
    cursor: pointer;

    svg {
        color: #595959;
    }
    
    input {
        outline: none;
        background-color: transparent;
        border-style: none;
        height: 100%;
        font-size: 15px;
    }
`;

export const ParentModalStyled = styled.div`
    z-index: 9;
    position: absolute;
    width: 100%;
`;

export const ContainerModalStyled = styled(Paper)`
    z-index: 9;
    position: absolute;
    max-height: 400px;
    overflow-y: auto;
`;

export const ItemModalStyled = styled.div`
    padding: 10px;
    cursor: pointer;
    &:hover {
        background-color: #ececec;
    }
`;


